import { FC, useRef } from 'react';
import s from './MarketingModalButton.module.scss';
import { ReactComponent as Arrow } from "./button_arrow.svg";

type ButtonType = {
    title: string
    onClick: () => void
    styles?: React.CSSProperties
    type?: string
    isLoading?: boolean | undefined
    Icon?: any,
    notArrow?: boolean;
}

export const MarketingModalButton: FC<ButtonType> = ({title, onClick, notArrow, styles, type = "default", isLoading, Icon}) => {

    // ### State
    const arrow_ref = useRef<HTMLDivElement>(null)
    const button_ref = useRef<HTMLDivElement>(null)

    // ### Effects

    // ### Functions
    function HandleHover(event: string){
        const line = arrow_ref.current?.children[0].children[0]
        if(event === "onMouseEnter" && line && button_ref.current){
            line.setAttribute('d', "M-14 8H43");
            arrow_ref.current.style.width = "60px";
        }
        else if(event === "onMouseLeave" && line && button_ref.current){
            line.setAttribute('d', "M26 8H43");
            arrow_ref.current.style.width = "20px";
        }
    }

    // ### Views

    return(
        <div 
            style={{...styles}}
            className={`${s.button}`} 
            ref={button_ref} 
            onClick={onClick} 
            onMouseEnter={()=>HandleHover("onMouseEnter")} 
            onMouseLeave={()=>HandleHover("onMouseLeave")}
        >
        <>
            {title?.length ? <span>{title}</span> : null}
            {!notArrow && <div className={s.arrow_wrapper} ref={arrow_ref}><Arrow/></div>}
        </>
        </div>
    )
}